import { NarrowLayout } from "source/Layout"

export function DonationThankYou() {
  return (
    <NarrowLayout>
      <h1>TODO: create thank you page</h1>
    </NarrowLayout>
  )
}
